module.exports = __webpack_public_path__ + "static/media/territorio.da7fd810.png";